import React, {Component} from 'react';
import {Link, withRouter} from 'react-router-dom';
import menus from '../../../utils/router/menus';
import partnerMenus from '../../../utils/router/partnerMenus';
import {Trans, withTranslation} from 'react-i18next';
import classnames from 'classnames';
import _toLower from 'lodash/toLower';
import _find from 'lodash/find';
import {connect} from 'react-redux';
import {switchMenu, closeMenu, extendMenu} from './reducer';
import {bindActionCreators} from 'redux';
import _get from 'lodash/get';
import PerfectScrollbar from 'react-perfect-scrollbar';
import subscriptionUtils from '../../../utils/subscriptionUtils';
import globals from '../../../utils/config/globals';
import partnerUtils from '../../../utils/partnerUtils';
import _isEmpty from 'lodash/isEmpty';
import store from 'store';
import moment from 'moment';
import './index.css';
import smbUtils from '../../../utils/smbUtils';
import storeUtils from '../../../utils/storeUtils';

@withRouter
@withTranslation()
@connect(
  state => ({
    isOpened: state.components.layout.sidebar.isOpened,
    asideMenuOn: state.components.layout.sidebar.asideMenuOn,
    extendMenuOn: state.components.layout.sidebar.extendMenuOn,
    accountSummary: state.components.auth.accountSummary,
    tutorialMode: state.components.tutorial.tutorialMode,
    stepIndex: state.components.tutorial.stepIndex,
    functionType: state.components.auth.accountSummary.customer.functionType,
  }),
  dispatch => bindActionCreators({switchMenu, closeMenu, extendMenu}, dispatch)
)
export default class Sidebar extends Component {
  isUnderlyingLink = (menu, pathname) => {
    if (_toLower(menu.link) === pathname) {
      return true;
    }
    if (menu.sublinks && _find(menu.sublinks, l => _toLower(l) === pathname)) {
      return true;
    }
    if (!menu.items) {
      return false;
    }
    for (let i = 0; i < menu.items.length; i++) {
      if (this.isUnderlyingLink(menu.items[i], pathname)) {
        return true;
      }
    }
  };

  isActive = (menu, pathname) => {
    if (_toLower(pathname).startsWith(_toLower(menu.link))) {
      return true;
    }
    return menu.sublinks && _find(menu.sublinks, l => _toLower(l) === pathname);
  };

  activeIconStyle = (menu, pathname) => {
    if (_toLower(menu.link) === pathname) {
      return {color: '#5d78ff'};
    }
    return menu.sublinks && _find(menu.sublinks, l => _toLower(l) === pathname)
      ? {color: '#5d78ff'}
      : {color: '#cacad2'};
  };

  showMenu = menuItems => {
    const {accountSummary} = this.props;
    const privileges = accountSummary.privileges;
    const ps = _get(menuItems, 'privileges', '');
    const ppp = ps.length ? ps.split(',') : [];
    const hasPermission = !ppp.length || ppp.some(p => privileges.includes(p));
    if (!hasPermission) return false;
    const isOverdue = subscriptionUtils.isOverdue(accountSummary);
    if (!isOverdue) return true;

    const mid = _get(menuItems, 'id', null);
    const availableMenus = globals.expiredAvailableMenus;
    return availableMenus.includes(mid);
  };

  getMenu = () => {
    const {t, accountSummary} = this.props;
    const isUpgrade = _get(accountSummary, 'customer.upgraded');
    const functionType = _get(accountSummary, 'customer.functionType');
    const isPartnerSite = partnerUtils.isPartnerSite();
    if (isPartnerSite) {
      return partnerMenus(t);
    }
    return menus(t, isUpgrade, functionType, accountSummary);
  };

  isLabelNewFeature = menuId => {
    const {functionType} = this.props;
    const {accountSummary} = this.props;
    const {customerId} = smbUtils.customerInfo(accountSummary);

    if (!smbUtils.isShowNewLabel(accountSummary, 14)) return false;

    if (functionType === 'SKINCARE_PRO') {
      let newFeatureMenuId = [];
      if (smbUtils.isShowNewLabel(accountSummary, 14)) {
        newFeatureMenuId = [...newFeatureMenuId, ...[1140, 1120, 1210, 1150]];
        if (storeUtils.getUpdatedSuccessFromVersion(customerId, 1)) {
          newFeatureMenuId = [...newFeatureMenuId, ...[7110, 9170]];
        }
        if (newFeatureMenuId.includes(menuId)) return true;
      } else {
        storeUtils.removeUpdatedSuccessFromVersion(customerId, 1);
      }
    }

    return false;
  };

  render() {
    const {
      location,
      switchMenu,
      isOpened,
      asideMenuOn,
      closeMenu,
      extendMenu,
      extendMenuOn,
      accountSummary,
      tutorialMode,
      stepIndex,
    } = this.props;

    const isUpgrade = _get(accountSummary, 'customer.upgraded');
    const accountId = _get(accountSummary, 'customer.accountId');
    const pathname = _toLower(location.pathname);

    const rootMenus = this.getMenu();
    const width = window.innerWidth;

    return (
      <>
        <div
          className={classnames({
            'kt-aside': true,
            'kt-aside--fixed': true,
            'kt-grid__item': true,
            'kt-grid': true,
            'kt-grid--desktop': true,
            'kt-grid--hor-desktop': true,
            'kt-aside--on': asideMenuOn,
          })}
        >
          <button className="kt-aside-close" onClick={() => closeMenu()}>
            <i className="la la-remove" />
          </button>
          <PerfectScrollbar>
            <div className="kt-aside-menu-wrapper kt-grid__item kt-grid__item--fluid">
              <div className="kt-aside-menu kt-scroll">
                <ul className="kt-menu__nav">
                  {!asideMenuOn && (
                    <li className="kt-menu__item kt-menu__item--submenu">
                      <div
                        className="kt-menu__link"
                        onClick={() => extendMenu()}
                      >
                        <span className="kt-menu__link-icon">
                          <i className="la la-bars" />
                        </span>
                        {(extendMenuOn || asideMenuOn) && (
                          <span className="kt-menu__link-text">
                            <Trans i18nKey="c.l.sidebar.0000.title">
                              Main Menu
                            </Trans>
                          </span>
                        )}
                      </div>
                    </li>
                  )}
                  {!_isEmpty(rootMenus) &&
                    rootMenus.map(
                      (m, i) =>
                        m.items &&
                        m.items.map((mm, ii) => (
                          <>
                            {mm && this.showMenu(mm) && (
                              <li
                                key={'item-' + i + '-' + ii}
                                className={classnames({
                                  'kt-menu__item': true,
                                  'kt-menu__item--submenu': true,
                                  'kt-menu__item--active':
                                    mm.link === pathname ||
                                    this.isUnderlyingLink(mm, pathname),
                                  'kt-menu__item--open': !_isEmpty(mm),
                                  'kt-menu__item--expanded': this.isUnderlyingLink(
                                    mm,
                                    pathname
                                  ),
                                })}
                                aria-haspopup="true"
                              >
                                <Link
                                  to={mm.link}
                                  className="kt-menu__link"
                                  style={{
                                    pointerEvents:
                                      mm.items &&
                                      mm.items.length === 0 &&
                                      'none',
                                  }}
                                  onClick={() => closeMenu()}
                                >
                                  <span className="kt-menu__item-here" />
                                  <span
                                    className="kt-menu__link-icon"
                                    style={this.activeIconStyle(mm, pathname)}
                                  >
                                    <i className={mm.icon} />
                                  </span>
                                  {(extendMenuOn || asideMenuOn) && (
                                    <span className="kt-menu__link-text">
                                      {mm.title}
                                    </span>
                                  )}
                                </Link>
                                {(extendMenuOn || asideMenuOn) &&
                                  mm.items &&
                                  !!mm.items.length && (
                                    <div className="kt-menu__submenu">
                                      <span className="kt-menu__arrow" />
                                      <ul className="kt-menu__subnav">
                                        {mm.items.map((mmm, iii) => (
                                          <>
                                            {mmm && this.showMenu(mmm) && (
                                              <li
                                                key={'sub-item-' + iii}
                                                className={classnames({
                                                  'kt-menu__item': true,
                                                  'kt-menu__item--open':
                                                    isOpened &&
                                                    isOpened[
                                                      mmm['privileges']
                                                    ] &&
                                                    !_isEmpty(mmm.items),
                                                  'kt-menu__item--active': this.isActive(
                                                    mmm,
                                                    pathname
                                                  ),
                                                })}
                                                aria-haspopup="true"
                                              >
                                                {
                                                  <Link
                                                    to={mmm.link}
                                                    className={`kt-menu__link ${
                                                      mmm.className
                                                    }`}
                                                    onClick={() => {
                                                      if (!_isEmpty(mmm.items))
                                                        switchMenu(
                                                          mmm['privileges']
                                                        );
                                                      closeMenu();
                                                    }}
                                                  >
                                                    <i className="kt-menu__link-bullet kt-menu__link-bullet--dot">
                                                      <span />
                                                    </i>
                                                    {this.isLabelNewFeature(
                                                      mmm.id
                                                    ) ? (
                                                      <span
                                                        className="kt-menu__link-text"
                                                        style={{
                                                          position: 'relative',
                                                        }}
                                                      >
                                                        <div>{mmm.title}</div>
                                                        <div>
                                                          <div className="pf-smb-menu__new-feature__icon" />
                                                        </div>
                                                      </span>
                                                    ) : (
                                                      <span
                                                        className="kt-menu__link-text"
                                                        style={{
                                                          position: 'relative',
                                                        }}
                                                      >
                                                        <div>{mmm.title}</div>
                                                      </span>
                                                    )}

                                                    {!_isEmpty(mmm.items) && (
                                                      <i className="kt-menu__ver-arrow la la-angle-right" />
                                                    )}
                                                  </Link>
                                                }

                                                {!_isEmpty(mmm.items) && (
                                                  <div className="kt-menu__submenu">
                                                    <span className="kt-menu__arrow" />
                                                    <ul className="kt-menu__subnav">
                                                      {mmm.items.map(
                                                        (mmmm, iiii) => (
                                                          <li
                                                            key={
                                                              'sub-sub-item-' +
                                                              iiii
                                                            }
                                                            className={classnames(
                                                              {
                                                                'kt-menu__item': true,
                                                                'kt-menu__item--active': this.isActive(
                                                                  mmmm,
                                                                  pathname
                                                                ),
                                                              }
                                                            )}
                                                            style={{
                                                              display:
                                                                mmmm.shouldUpgrade &&
                                                                'none',
                                                            }}
                                                            aria-haspopup="true"
                                                          >
                                                            {
                                                              <Link
                                                                to={mmmm.link}
                                                                className="kt-menu__link"
                                                                onClick={
                                                                  closeMenu
                                                                }
                                                                style={{
                                                                  height:
                                                                    '48px',
                                                                }}
                                                              >
                                                                <i className="kt-menu__link-bullet kt-menu__link-bullet--line">
                                                                  <span />
                                                                </i>
                                                                <span
                                                                  className="kt-menu__link-text"
                                                                  style={{
                                                                    position:
                                                                      'relative',
                                                                    width:
                                                                      '200px',
                                                                  }}
                                                                >
                                                                  <div>
                                                                    {mmmm.title}
                                                                  </div>
                                                                  {this.isLabelNewFeature(
                                                                    mmmm.id
                                                                  ) && (
                                                                    <div>
                                                                      <div className="pf-smb-menu__new-feature__icon" />
                                                                    </div>
                                                                  )}
                                                                </span>
                                                              </Link>
                                                            }
                                                          </li>
                                                        )
                                                      )}
                                                    </ul>
                                                  </div>
                                                )}
                                              </li>
                                            )}
                                          </>
                                        ))}
                                      </ul>
                                    </div>
                                  )}
                              </li>
                            )}
                          </>
                        ))
                    )}
                </ul>
              </div>
            </div>
          </PerfectScrollbar>
        </div>
        {asideMenuOn && (
          <div className="kt-aside-overlay" onClick={() => closeMenu()} />
        )}
      </>
    );
  }
}
